import { alpha, Button, Stack, Typography } from '@mui/material';

export function NumberStepper(props: {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  min?: number;
}) {
  function handleChange(value: number) {
    if (props.max !== undefined && value > props.max) {
      return;
    }
    if (props.min !== undefined && value < props.min) {
      return;
    }
    props.onChange(value);
  }
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        background: (t) => alpha(t.palette.primary.light, 0.3),
        borderRadius: 1,
      }}
    >
      <Button
        variant="contained"
        onClick={() => handleChange(props.value - 1)}
        disabled={props.min !== undefined && props.value <= props.min}
        sx={{
          minWidth: (t) => t.spacing(5),
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          boxShadow: 'none',
        }}
      >
        -
      </Button>
      <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: '1.2rem',
          minWidth: 25,
          textAlign: 'center',
          boxShadow: 'none',
        }}
      >
        {props.value}
      </Typography>
      <Button
        variant="contained"
        sx={{
          minWidth: (t) => t.spacing(5),
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          boxShadow: 'none',
        }}
        onClick={() => handleChange(props.value + 1)}
        disabled={props.max !== undefined && props.value >= props.max}
      >
        +
      </Button>
    </Stack>
  );
}
